module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - PRODUCT - " + _vm._s(_vm.categoryName))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#888",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [(_vm.category == '1') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('114')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '2') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('115')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('107')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_5')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('57')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('59')
      }
    }
  }, [_vm._v(" CPE 135A")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('63')
      }
    }
  }, [_vm._v("ACR")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('118')
      }
    }
  }, [_vm._v(" PVC  Resin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('61')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('60')
      }
    }
  }, [_vm._v(" PE wax")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('71')
      }
    }
  }, [_vm._v(" Optical brightener")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('96')
      }
    }
  }, [_vm._v(" Nano calcium carbonate")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '5') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('69')
      }
    }
  }, [_vm._v(" Sodium Acid Pyrophosphate SAPP")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('117')
      }
    }
  }, [_vm._v(" Purified Terephthalic Acid")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('70')
      }
    }
  }, [_vm._v(" Dicyandiamide")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('108')
      }
    }
  }, [_vm._v(" Fumed Silica")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('106')
      }
    }
  }, [_vm._v(" silicon carbide abrasive")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('79')
      }
    }
  }, [_vm._v(" Poly Aluminium Chloride (PAC)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('56')
      }
    }
  }, [_vm._v(" Magnesium hydroxide")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('66')
      }
    }
  }, [_vm._v(" Barium Sulfate")])])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product107_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product57_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product59_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product63_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product118_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product61_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product60_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product71_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product96_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product69_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product117_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product70_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product108_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product106_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product79_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product56_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product66_logo.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fdd724a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/category.vue
// module id = 1394
// module chunks = 1